import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  Box,
  Button,
  Card,
  CircularProgress,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useStyles } from "../../../theme/appStyles";
import { useNavigate } from "react-router";
import {
  useGetAllByPolicyNumberQuery,
  useGetCustomerRelationQuery,
  useGetCustomerQuery,
  useGetFinalSummaryReportQuery,
  useGetProductBrandQuery,
  useGetProductQuery,
} from "../../../Api/attoDeskApi";
import {
  ICustomer,
  IFinalSummaryReport,
  IPolicy,
  IProductBrand,
  IProductPopUP,
  ICustomerRelative2,
  ICustomerRelative,
} from "../../../Api/Interface/api.interface";
import dayjs, { Dayjs } from "dayjs";
import { useParams } from "react-router-dom";
import ReactToPrint from "react-to-print";
import LocalPrintshopSharpIcon from "@mui/icons-material/LocalPrintshopSharp";
import LogoMain from "../../../Images/logo.png";
import { formatPhoneNumberForDisplay } from "../../../Components/Validation/validationUtils";
import { toProperCase } from "../../../Components/Validation/toProperCase";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { styled } from "@mui/material/styles";
import { formatNumber } from "../../../Components/formatNumber/formatNumber";
import { Link } from "react-router-dom";

const capitalizeFirstLetter = (name: string | null | undefined) => {
  if (!name) return "";
  return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
};

// const PrintContainer = styled("div")({
//   "@media print": {
//     pageBreakInside: "avoid",
//     marginTop: "300px",
//     // table: {
//     //   borderCollapse: "collapse",
//     //   width: "100%",
//     // },
//     // "th, td": {
//     //   border: "1px solid #767c83 !important",
//     //   padding: "12px !important",
//     //   color: "#000 !important",
//     // },
//     // "thead th": {
//     //   backgroundColor: "#dadee5 !important",
//     // },
//     // "table *": {
//     //   WebkitPrintColorAdjust: "exact",
//     //   printColorAdjust: "exact",
//     // },
//   },
//   // "@page": {
//   //   paddingTop: "300px",
//   //   paddingBottom: "300px",
//   // },
// });

// const PrintContainer = styled("div")({
//   "@page": {
//     paddingTop: "30px",
//     paddingBottom: "30px",
//     // margin: "10mm",
//   },
//   "&::after": {
//     content: '"Page " counter(page) " of " counter(pages)',
//     position: "fixed",
//     bottom: "1mm",
//     left: 0,
//     right: 0,
//     textAlign: "center",
//     fontSize: "12px",
//   },
// });

// const PrintContainer = styled("div")({
//   "@media print": {
//     // Reset counter once at the start

//     "@page": {
//       paddingTop: "30px",
//       paddingBottom: "30px",
//       // margin: "10mm", // optional
//     },
//     counterReset: "page",

//     // Page number footer
//     "&::after": {
//       counterIncrement: "page", // increment for every page
//       content: '"Page " counter(page)', // ✅ remove counter(pages)
//       position: "fixed",
//       bottom: "5mm",
//       left: 0,
//       right: 0,
//       textAlign: "center",
//       fontSize: "12px",
//     },
//   },
// });

// const PrintContainer = styled("div")({
//   "@media print": {
//     "@page": {
//       margin: "20mm", // create margin for footer
//     },
//     position: "relative",

//     // Add page number footer
//     "&::after": {
//       content: '"Page " counter(page) " of " counter(pages)',
//       position: "fixed",
//       bottom: "10mm",
//       left: 0,
//       right: 0,
//       textAlign: "center",
//       fontSize: "12px",
//       color: "#333",
//     },
//   },
// });

// const PrintContainer = styled("div")({
//   "@page": {
//     paddingTop: "30px",
//     paddingBottom: "30px",
//     "@bottom-right": {
//       content: "Page " counter(page),
//     }
//   },
// });

const PrintContainer = styled("div")({
  "@media print": {
    "@page": {
      paddingTop: "30px",
      paddingBottom: "30px",
      // "@bottom-right": {
      //   content: '"Page " counter(page)',
      //   color: "#333",
      //   fontSize: "12px"
      // }
    },
  },
});

const Index = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const theme = useTheme();
  const { customerId, policyNumber } = useParams<{
    customerId: string;
    policyNumber: string;
  }>();

  const componentRef = useRef<HTMLDivElement>(null);
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const { data, isLoading, isError } = useGetCustomerQuery({
    searchText: "",
    id: String(customerId),
  });

  const {
    data: customerProjectData,
    isLoading: customerProjectDataIsLoading,
    refetch: cutomerProjectRefetch,
    isError: cutomerProjectisError,
  } = useGetAllByPolicyNumberQuery({
    searchText: "",
    id: "",
    policyCustomerId: String(customerId),
    policyNumber: String(policyNumber),
  });

  const {
    data: summaryReportData,
    isLoading: summaryReportIsLoading,
    isError: SummaryReportIsError,
  } = useGetFinalSummaryReportQuery({
    id: String(policyNumber),
  });

  const { data: brandListData, isLoading: brandIsLoading } =
    useGetProductBrandQuery({
      searchText: "",
      isActive: true,
    });

  const { data: customerFullData, isLoading: customerFullDataISLoading } =
    useGetCustomerQuery({
      searchText: "",
      id: "",
    });

  const {
    data: productData,
    isLoading: productDataIsLoading,
    isError: productDataError,
  } = useGetProductQuery({
    searchText: "",
    id: "",
    productBrandId: null,
    productCategoryId: null,
    productTagIds: null,
    productViewOnline: null,
    createdDateStart: null,
    createdDateEnd: null,
    createdDate: null,
  });

  const policyCustomerId = String(customerId || "");

  const {
    data: relativeData,
    isLoading: relativeIsLoading,
    isError: relativeError,
  } = useGetCustomerRelationQuery(
    { policyCustomerId },
    { skip: !policyCustomerId }
  );

  const customer = useMemo(() => {
    if (data && Array.isArray(data.data) && data.data.length > 0) {
      return data.data[0] as ICustomer;
    }
    return null;
  }, [data]);

  const project: IPolicy[] = useMemo(() => {
    if (customerProjectData && Array.isArray(customerProjectData.data)) {
      return customerProjectData.data as IPolicy[];
    }
    return [];
  }, [customerProjectData]);

  const brandList = useMemo(() => {
    return brandListData?.data as IProductBrand[];
  }, [brandListData?.data]);

  const customerAllList = useMemo(() => {
    return customerFullData?.data as ICustomer[];
  }, [customerFullData?.data]);

  const productList = useMemo(() => {
    return productData?.data as IProductPopUP[];
  }, [productData?.data]);

  const finalSummaryList = useMemo(() => {
    return summaryReportData?.data as IFinalSummaryReport;
  }, [summaryReportData?.data]);

  const relationDataList = useMemo(() => {
    return (relativeData?.data ?? []) as ICustomerRelative2[];
  }, [relativeData?.data]);

  const brandMap = useMemo(() => {
    const map = new Map();
    brandList?.forEach((category) => {
      map.set(category.id, category.productBrandName);
    });
    return map;
  }, [brandList]);

  const productMap = useMemo(() => {
    const map = new Map();
    productList?.forEach((brand) => {
      map.set(brand.id, brand.productName);
    });
    return map;
  }, [productList]);

  const relativeMap = useMemo(() => {
    const map = new Map();
    relationDataList?.forEach((item) => {
      map.set(item.id, `${toProperCase(item?.related_customer_name)}`);
    });
    return map;
  }, [relationDataList]);

  const customerMap = useMemo(() => {
    const map = new Map();
    customerAllList?.forEach((category) => {
      map.set(
        category.id,
        capitalizeFirstLetter(category.customerFirstName) +
          " " +
          capitalizeFirstLetter(category.customerLastName)
      );
    });
    return map;
  }, [customerAllList]);

  const today = dayjs();
  const formattedDate = dayjs(today).format("MMM D, YYYY");

  const formatAddress = (
    customerAddresLine: string,
    customerCity: string,
    customerProvince: string,
    customerPostalCode: string
  ) => {
    return `${capitalizeFirstLetter(
      customerAddresLine
    )} ${capitalizeFirstLetter(customerCity)},\n${capitalizeFirstLetter(
      customerProvince
    )} ${capitalizeFirstLetter(customerPostalCode)}`;
  };

  const AddressOrder = formatAddress(
    customer?.customerAddresLine || "",
    customer?.customerCity || "",
    customer?.customerProvince || "",
    customer?.customerPostalCode || ""
  );

  const fontwhighte = 550;

  if (
    summaryReportIsLoading ||
    isLoading ||
    productDataIsLoading ||
    customerProjectDataIsLoading ||
    brandIsLoading ||
    customerFullDataISLoading ||
    relativeIsLoading
  )
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="10vh"
      >
        <CircularProgress />
      </Box>
    );

  return (
    <div>
      <Grid container spacing={2}>
        <Grid item lg={12} md={12} sm={12} xs={12}>
          <Card className={classes.quotesCardInvoice}>
            <Grid container spacing={1} px={2} py={2}>
              <Grid
                item
                lg={12}
                md={12}
                sm={12}
                xs={12}
                sx={{ display: "flex", justifyContent: "flex-end" }}
              >
                <Grid
                  container
                  spacing={1}
                  justifyContent="flex-end"
                  sx={{ display: "flex" }}
                >
                  <Grid item>
                    <Link
                      to={`/customer/${customerId}/summary/pdf/${String(
                        policyNumber
                      )}`}
                      className={classes.iconLinkPropNormal}
                    >
                      <Button
                        className={classes.addNewButton}
                        onClick={() =>
                          navigate(
                            `/customer/${customerId}/summary/pdf/${String(
                              policyNumber
                            )}`
                          )
                        }
                      >
                        Type 1 pdf
                      </Button>
                    </Link>
                  </Grid>
                  <Grid item>
                    <Button
                      variant="outlined"
                      startIcon={<ArrowBackIcon />}
                      className={classes.addButton}
                      onClick={() => navigate(-1)}
                    >
                      Back
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Card>
        </Grid>
        <Grid item lg={12} md={12} sm={12} xs={12}>
          <PrintContainer ref={componentRef}>
            <Card className={classes.quotesCardInvoice}>
              <Grid container spacing={"2px"} padding={"1px"}>
                <Grid
                  item
                  lg={12}
                  md={12}
                  sm={12}
                  xs={12}
                  className={classes.titleGrid}
                >
                  <Grid
                    container
                    className={classes.titleGridInvoice}
                    justifyContent={"space-between"}
                    padding={2}
                  >
                    <Grid item lg={12} md={12} sm={12} xs={12} pb={2}>
                      <Grid container spacing={1}>
                        {/* <Grid
                          item
                          lg={12}
                          md={12}
                          sm={12}
                          xs={12}
                          display="center"
                          justifyContent="center"
                          alignItems="center"
                          // sx={{
                          //   "@media print": {
                          //     pageBreakBefore: "always",
                          //   },
                          // }}
                        >
                          <Typography className={classes.bodyPrintHeading}>
                            GT BROKERS LTD - INSURANCE POLICY SUMMARIES -
                            {(customer?.customerFirstName || "") +
                              " " +
                              (customer?.customerLastName || "")}
                          </Typography>
                        </Grid> */}
                        <Grid
                          item
                          lg={12}
                          md={12}
                          sm={12}
                          xs={12}
                          display="flex"
                          justifyContent="flex-end"
                          alignItems="center"
                          // sx={{
                          //   "@media print": {
                          //     pageBreakBefore: "always",
                          //   },
                          // }}
                        >
                          <img
                            src={LogoMain}
                            alt="AttoDesk Login"
                            style={{
                              width: "250px",
                              height: "auto",
                              display: "block",
                            }}
                          />
                        </Grid>
                        <Grid item lg={12} md={12} sm={12} xs={12} pb={1}>
                          <Typography className={classes.bodyPrint1}>
                            <span style={{ fontWeight: fontwhighte }}>
                              Date :&nbsp;&nbsp;
                            </span>{" "}
                            {formattedDate}
                          </Typography>
                        </Grid>
                        <Grid item lg={12} md={12} sm={12} xs={12} pb={1}>
                          {customer &&
                            (customer.customerFirstName ||
                              customer.customerLastName) && (
                              <Typography
                                className={classes.bodyPrintHeading}
                                sx={{
                                  textTransform: "uppercase",
                                  color: "black",
                                }}
                              >
                                {(customer?.customerFirstName || "") +
                                  " " +
                                  (customer?.customerLastName || "")}
                              </Typography>
                            )}
                          {customer &&
                            (customer.customerAddresLine ||
                              customer.customerCity) && (
                              <Typography
                                className={classes.bodyPrintHeading}
                                sx={{
                                  textTransform: "uppercase",
                                  color: "black",
                                }}
                              >
                                {(customer?.customerAddresLine || "") +
                                  " " +
                                  (customer?.customerCity || "")}
                              </Typography>
                            )}
                          {customer &&
                            (customer.customerProvince ||
                              customer.customerPostalCode) && (
                              <Typography
                                className={classes.bodyPrintHeading}
                                sx={{
                                  textTransform: "uppercase",
                                  color: "black",
                                }}
                              >
                                {(customer?.customerProvince || "") +
                                  " " +
                                  (customer?.customerPostalCode || "")}
                              </Typography>
                            )}
                        </Grid>
                        <Grid item lg={12} md={12} sm={12} xs={12} pb={1}>
                          {customer && customer.customerHomeMobileNum && (
                            <Typography className={classes.bodyPrint1}>
                              <span style={{ fontWeight: fontwhighte }}>
                                Home Phone :&nbsp;&nbsp;
                              </span>{" "}
                              {formatPhoneNumberForDisplay(
                                customer.customerHomeMobileNum
                              )}
                            </Typography>
                          )}
                          {customer && customer.customerMobileNum && (
                            <Typography className={classes.bodyPrint1}>
                              <span style={{ fontWeight: fontwhighte }}>
                                Cell Phone :&nbsp;&nbsp;
                              </span>{" "}
                              {formatPhoneNumberForDisplay(
                                customer.customerMobileNum
                              )}
                            </Typography>
                          )}
                          {customer && customer.customerWorkMobileNum && (
                            <Typography className={classes.bodyPrint1}>
                              <span style={{ fontWeight: fontwhighte }}>
                                Work Phone :&nbsp;&nbsp;
                              </span>{" "}
                              {formatPhoneNumberForDisplay(
                                customer.customerWorkMobileNum
                              )}
                            </Typography>
                          )}
                          {customer && customer.customerEmail && (
                            <Typography className={classes.bodyPrint1}>
                              <span style={{ fontWeight: fontwhighte }}>
                                Email :&nbsp;&nbsp;
                              </span>{" "}
                              {customer.customerEmail?.toLowerCase()}
                            </Typography>
                          )}
                        </Grid>
                        <Grid
                          item
                          lg={12}
                          md={12}
                          sm={12}
                          xs={12}
                          className={classes.policySummaryBox}
                          textAlign={"center"}
                          justifyContent={"center"}
                          mb={1}
                        >
                          <Typography className={classes.policySummaryTitile}>
                            Policy Summaries
                          </Typography>
                        </Grid>
                        <Grid item lg={12} md={12} sm={12} xs={12} pb={2}>
                          {summaryReportIsLoading ? (
                            <TableRow>
                              <TableCell colSpan={20} align="center">
                                <Box
                                  display="flex"
                                  justifyContent="center"
                                  alignItems="center"
                                  height="10vh"
                                >
                                  <CircularProgress />
                                </Box>
                              </TableCell>
                            </TableRow>
                          ) : SummaryReportIsError ? (
                            <TableRow>
                              <TableCell colSpan={20} align="center">
                                "Error fetching data"
                              </TableCell>
                            </TableRow>
                          ) : summaryReportData?.policies &&
                            Object.entries(summaryReportData.policies)
                              .length === 0 ? (
                            <TableRow>
                              <TableCell colSpan={3} align="center">
                                No data available
                              </TableCell>
                            </TableRow>
                          ) : (
                            (finalSummaryList?.policySummaryIds || []).map(
                              (policyNumber: string, index: number) => {
                                const policies =
                                  summaryReportData?.policies as Record<
                                    string,
                                    IPolicy[]
                                  >;
                                const records = policies?.[policyNumber] || [];
                                const firstPolicy = records[0];
                                return (
                                  <div key={index}>
                                    <Grid container spacing={1}>
                                      <Grid
                                        item
                                        lg={6}
                                        md={6}
                                        sm={6}
                                        xs={6}
                                        pt={1}
                                      >
                                        {firstPolicy.policyNumber && (
                                          <Typography
                                            className={classes.bodyPrint1}
                                          >
                                            <span
                                              style={{
                                                fontWeight: fontwhighte,
                                              }}
                                            >
                                              Policy Number :&nbsp;&nbsp;
                                            </span>{" "}
                                            {firstPolicy.policyNumber || " "}
                                          </Typography>
                                        )}
                                        {firstPolicy.policyInsuranceCompanyId && (
                                          <Typography
                                            className={classes.bodyPrint1}
                                          >
                                            <span
                                              style={{
                                                fontWeight: fontwhighte,
                                              }}
                                            >
                                              Company Name :&nbsp;&nbsp;
                                            </span>{" "}
                                            {brandMap.get(
                                              Number(
                                                firstPolicy.policyInsuranceCompanyId
                                              )
                                            ) || ""}
                                          </Typography>
                                        )}
                                        {firstPolicy.policyIssueDate && (
                                          <Typography
                                            className={classes.bodyPrint1}
                                          >
                                            <span
                                              style={{
                                                fontWeight: fontwhighte,
                                              }}
                                            >
                                              Issue Date :&nbsp;&nbsp;
                                            </span>{" "}
                                            {firstPolicy.policyIssueDate
                                              ? dayjs(
                                                  firstPolicy.policyIssueDate
                                                ).format("MMM D, YYYY")
                                              : ""}
                                          </Typography>
                                        )}
                                      </Grid>
                                      <Grid
                                        item
                                        lg={6}
                                        md={6}
                                        sm={6}
                                        xs={6}
                                        pt={1}
                                      >
                                        {firstPolicy.policyPayor && (
                                          <Typography
                                            className={classes.bodyPrint1}
                                          >
                                            <span
                                              style={{
                                                fontWeight: fontwhighte,
                                              }}
                                            >
                                              Payor Name :&nbsp;&nbsp;
                                            </span>{" "}
                                            {firstPolicy.policyPayor || " "}
                                          </Typography>
                                        )}
                                        {firstPolicy.policyDrawDay && (
                                          <Typography
                                            className={classes.bodyPrint1}
                                          >
                                            <span
                                              style={{
                                                fontWeight: fontwhighte,
                                              }}
                                            >
                                              Draw Day :&nbsp;&nbsp;
                                            </span>{" "}
                                            {firstPolicy.policyDrawDay || " "}
                                          </Typography>
                                        )}
                                      </Grid>
                                      <Grid
                                        item
                                        lg={12}
                                        md={12}
                                        sm={12}
                                        xs={12}
                                        mt={1}
                                        className={classes.titleGrid}
                                      >
                                        <Grid
                                          container
                                          spacing={1}
                                          key={policyNumber}
                                        >
                                          <Grid
                                            item
                                            lg={12}
                                            md={12}
                                            sm={12}
                                            xs={12}
                                          >
                                            <TableContainer>
                                              <Table
                                                className={classes.tableReport}
                                              >
                                                <TableHead
                                                  className={
                                                    classes.tableHeaderRowReport
                                                  }
                                                >
                                                  <TableRow>
                                                    <TableCell
                                                      className={
                                                        classes.tablheaderReport
                                                      }
                                                      sx={{
                                                        // textAlign: "center",
                                                        width: "60%",
                                                      }}
                                                    >
                                                      <Typography
                                                        className={
                                                          classes.bodyPrint1
                                                        }
                                                      >
                                                        <strong>Details</strong>
                                                      </Typography>
                                                    </TableCell>
                                                    <TableCell
                                                      className={
                                                        classes.tablheaderReport
                                                      }
                                                      sx={{
                                                        textAlign: "right",
                                                        width: "20%",
                                                      }}
                                                    >
                                                      <Typography
                                                        className={
                                                          classes.bodyPrint1
                                                        }
                                                      >
                                                        <strong>
                                                          Coverage Amount{" "}
                                                        </strong>
                                                      </Typography>
                                                    </TableCell>
                                                    <TableCell
                                                      className={
                                                        classes.tablheaderReport
                                                      }
                                                      sx={{
                                                        textAlign: "right",
                                                        width: "20%",
                                                      }}
                                                    >
                                                      <Typography
                                                        className={
                                                          classes.bodyPrint1
                                                        }
                                                      >
                                                        <strong>Premium</strong>
                                                      </Typography>
                                                    </TableCell>
                                                  </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                  {cutomerProjectisError ||
                                                  records.length === 0 ? (
                                                    <TableRow>
                                                      <TableCell
                                                        colSpan={8}
                                                        align="center"
                                                      >
                                                        {cutomerProjectisError
                                                          ? "Error fetching data"
                                                          : "No data available"}
                                                      </TableCell>
                                                    </TableRow>
                                                  ) : (
                                                    records.map(
                                                      (
                                                        policy: IPolicy,
                                                        index: number
                                                      ) => (
                                                        <TableRow
                                                          key={policy.id}
                                                        >
                                                          <TableCell
                                                            className={
                                                              classes.tablCellReport
                                                            }
                                                            sx={{
                                                              width: "60%",
                                                            }}
                                                          >
                                                            {policy.policyProductId && (
                                                              <Typography
                                                                className={
                                                                  classes.bodyPrintHeading
                                                                }
                                                                sx={{
                                                                  textTransform:
                                                                    "uppercase",
                                                                  color:
                                                                    "black",
                                                                  fontWeight:
                                                                    "400 !important",
                                                                }}
                                                              >
                                                                {productMap.get(
                                                                  Number(
                                                                    policy.policyProductId
                                                                  )
                                                                ) || ""}
                                                              </Typography>
                                                            )}
                                                            {policy.policyInsuredDetails &&
                                                              policy
                                                                .policyInsuredDetails
                                                                .length > 0 && (
                                                                <Typography
                                                                  className={
                                                                    classes.bodyPrint1
                                                                  }
                                                                >
                                                                  <span
                                                                    style={{
                                                                      fontWeight:
                                                                        fontwhighte,
                                                                    }}
                                                                  >
                                                                    Insured
                                                                    :&nbsp;&nbsp;
                                                                  </span>{" "}
                                                                  <strong>
                                                                    {" "}
                                                                  </strong>{" "}
                                                                  {policy.policyInsuredDetails.map(
                                                                    (
                                                                      insuredId,
                                                                      index
                                                                    ) => {
                                                                      const customerName =
                                                                        relativeMap.get(
                                                                          Number(
                                                                            insuredId
                                                                          )
                                                                        ) || "";

                                                                      return (
                                                                        <span
                                                                          key={
                                                                            insuredId
                                                                          }
                                                                        >
                                                                          {
                                                                            customerName
                                                                          }
                                                                          {index <
                                                                            policy
                                                                              .policyInsuredDetails
                                                                              .length -
                                                                              1 &&
                                                                            ", "}
                                                                        </span>
                                                                      );
                                                                    }
                                                                  )}
                                                                </Typography>
                                                              )}
                                                            {(policy.policyIsLifeTimeExpiryDate ||
                                                              policy.policyExpiryDate) && (
                                                              <Typography
                                                                className={
                                                                  classes.bodyPrint1
                                                                }
                                                              >
                                                                {/* Expires :&nbsp;&nbsp; */}
                                                                <span
                                                                  style={{
                                                                    fontWeight:
                                                                      fontwhighte,
                                                                  }}
                                                                >
                                                                  Expires
                                                                  :&nbsp;&nbsp;
                                                                </span>{" "}
                                                                {policy.policyIsLifeTimeExpiryDate
                                                                  ? "Death"
                                                                  : policy.policyExpiryDate
                                                                  ? dayjs(
                                                                      policy.policyExpiryDate
                                                                    ).format(
                                                                      "MMM D, YYYY"
                                                                    )
                                                                  : "-"}
                                                              </Typography>
                                                            )}

                                                            {policy.policyPrimaryBenificariesNew &&
                                                              policy
                                                                .policyPrimaryBenificariesNew
                                                                .length > 0 && (
                                                                <Typography
                                                                  className={
                                                                    classes.bodyPrint1
                                                                  }
                                                                >
                                                                  {/* Beneficiaries :&nbsp;&nbsp; */}
                                                                  <span
                                                                    style={{
                                                                      fontWeight:
                                                                        fontwhighte,
                                                                    }}
                                                                  >
                                                                    Beneficiaries
                                                                    :&nbsp;&nbsp;
                                                                  </span>{" "}
                                                                  {/* {policy.policyPrimaryBenificariesNew.map(
                                                              (
                                                                insured,
                                                                index
                                                              ) => (
                                                                <span
                                                                  key={index}
                                                                >
                                                                  {toProperCase(
                                                                    insured.name
                                                                  )}{" "}
                                                                  {insured.payoutPercentage
                                                                    ? `- ${insured.payoutPercentage}%`
                                                                    : ""}
                                                                  {index <
                                                                    policy
                                                                      .policyPrimaryBenificariesNew
                                                                      .length -
                                                                      1 && ", "}
                                                                </span>
                                                              )
                                                            )} */}
                                                                  {policy.policyPrimaryBenificariesNew.map(
                                                                    (
                                                                      insuredId,
                                                                      index
                                                                    ) => {
                                                                      const customerName =
                                                                        relativeMap.get(
                                                                          Number(
                                                                            insuredId.column1
                                                                          )
                                                                        ) || "";

                                                                      return (
                                                                        <span
                                                                          key={
                                                                            index
                                                                          }
                                                                        >
                                                                          {
                                                                            customerName
                                                                          }
                                                                          {insuredId.payoutPercentage
                                                                            ? `- ${insuredId.payoutPercentage}%`
                                                                            : ""}
                                                                          {/* {insuredId.column2
                                                              ? ` (${insuredId.column2})`
                                                              : ""} */}
                                                                          {index <
                                                                            policy
                                                                              .policyPrimaryBenificariesNew
                                                                              .length -
                                                                              1 &&
                                                                            ", "}
                                                                        </span>
                                                                      );
                                                                    }
                                                                  )}
                                                                </Typography>
                                                              )}
                                                            {firstPolicy.policyRemark && (
                                                              <Typography
                                                                className={
                                                                  classes.bodyPrint1
                                                                }
                                                              >
                                                                <span
                                                                  style={{
                                                                    fontWeight:
                                                                      fontwhighte,
                                                                  }}
                                                                >
                                                                  Remarks:
                                                                </span>{" "}
                                                                <Typography
                                                                  className={
                                                                    classes.bodyPrint1
                                                                  }
                                                                  dangerouslySetInnerHTML={{
                                                                    __html:
                                                                      policy.policyRemark,
                                                                  }}
                                                                />
                                                                {/* {policy.policyRemark ||
                                                                  ""} */}
                                                              </Typography>
                                                            )}
                                                          </TableCell>
                                                          <TableCell
                                                            className={
                                                              classes.tablCellReport
                                                            }
                                                            sx={{
                                                              textAlign:
                                                                "right",
                                                              width: "20%",
                                                              verticalAlign:
                                                                "top",
                                                            }}
                                                          >
                                                            {policy.policyCoverageAmount && (
                                                              <Typography
                                                                className={
                                                                  classes.bodyPrintHeading
                                                                }
                                                                sx={{
                                                                  textTransform:
                                                                    "uppercase",
                                                                  color:
                                                                    "black",
                                                                }}
                                                              >
                                                                {formatNumber(
                                                                  policy.policyCoverageAmount ||
                                                                    "0.00"
                                                                )}
                                                              </Typography>
                                                            )}
                                                          </TableCell>
                                                          <TableCell
                                                            className={
                                                              classes.tablCellReport
                                                            }
                                                            sx={{
                                                              textAlign:
                                                                "right",
                                                              width: "20%",
                                                              verticalAlign:
                                                                "top",
                                                            }}
                                                          >
                                                            {policy.policyPremiumDetails && (
                                                              <Typography
                                                                className={
                                                                  classes.bodyPrintHeading
                                                                }
                                                                sx={{
                                                                  textTransform:
                                                                    "uppercase",
                                                                  color:
                                                                    "black",
                                                                }}
                                                              >
                                                                {formatNumber(
                                                                  policy.policyPremiumDetails ||
                                                                    "0.00"
                                                                )}
                                                              </Typography>
                                                            )}
                                                          </TableCell>
                                                        </TableRow>
                                                      )
                                                    )
                                                  )}
                                                  <TableRow>
                                                    <TableCell
                                                      className={
                                                        classes.tablCellReport
                                                      }
                                                      sx={{
                                                        width: "60%",
                                                      }}
                                                    >
                                                      <Typography
                                                        className={
                                                          classes.bodyPrint1
                                                        }
                                                      >
                                                        <span
                                                          style={{
                                                            fontWeight:
                                                              fontwhighte,
                                                          }}
                                                        >
                                                          Total for Policy
                                                          (including policy fee)
                                                        </span>{" "}
                                                      </Typography>
                                                    </TableCell>
                                                    <TableCell
                                                      className={
                                                        classes.tablCellReport
                                                      }
                                                      sx={{
                                                        textAlign: "right",
                                                        width: "20%",
                                                        verticalAlign: "top",
                                                      }}
                                                    >
                                                      <Typography
                                                        className={
                                                          classes.bodyPrintHeading
                                                        }
                                                        sx={{
                                                          textTransform:
                                                            "uppercase",
                                                          color: "black",
                                                        }}
                                                      >
                                                        {" "}
                                                      </Typography>
                                                    </TableCell>
                                                    <TableCell
                                                      className={
                                                        classes.tablCellReport
                                                      }
                                                      sx={{
                                                        textAlign: "right",
                                                        width: "20%",
                                                        verticalAlign: "top",
                                                      }}
                                                    >
                                                      <Typography
                                                        className={
                                                          classes.bodyPrintHeading
                                                        }
                                                        sx={{
                                                          textTransform:
                                                            "uppercase",
                                                          color: "black",
                                                        }}
                                                      >
                                                        {formatNumber(
                                                          firstPolicy.policyPremium ||
                                                            "0.00"
                                                        )}
                                                      </Typography>
                                                    </TableCell>
                                                  </TableRow>
                                                </TableBody>
                                              </Table>
                                            </TableContainer>
                                          </Grid>
                                        </Grid>
                                      </Grid>
                                    </Grid>
                                  </div>
                                );
                              }
                            )
                          )}
                        </Grid>

                        <Grid item lg={12} md={12} sm={12} xs={12} mt={5}>
                          <Typography
                            className={classes.bodyPrint1}
                            sx={{ textDecoration: "underline" }}
                          >
                            <strong>Additional Comments</strong>{" "}
                          </Typography>

                          {/* {finalSummaryList.policyTerms &&
                            finalSummaryList.policyTerms.length > 0 &&
                            finalSummaryList.policyTerms.map(
                              (policy, index) => {
                                return (
                                  <Grid key={policy.id} container>
                                    <Grid
                                      container
                                      spacing={2}
                                      alignItems="center"
                                      padding={1}
                                    >
                                      <Grid
                                        item
                                        lg={12}
                                        md={12}
                                        sm={12}
                                        xs={12}
                                        key={index}
                                      >
                                        <Grid
                                          container
                                          spacing={2}
                                          alignItems="center"
                                        >
                                          <Grid
                                            item
                                            lg={0.5}
                                            md={0.5}
                                            sm={0.5}
                                            xs={0.5}
                                            display="flex"
                                            justifyContent="flex-start"
                                            alignItems="flex-start"
                                          >
                                            <Typography
                                              sx={{
                                                fontSize: 13,
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                width: 18,
                                                height: 18,
                                                borderRadius: "50%",
                                                border: "1px solid",
                                                textAlign: "center",
                                                lineHeight: "13px",
                                                color: "black",
                                              }}
                                            >
                                              {"✔"}
                                            </Typography>
                                          </Grid>
                                          <Grid
                                            item
                                            lg={11.5}
                                            md={11.5}
                                            sm={11.5}
                                            xs={11.5}
                                          >
                                            <Typography
                                              className="headingSummary"
                                              sx={{
                                                pb: "2px",
                                                color: "black",
                                              }}
                                            >
                                              {policy.policyTermsDescription}
                                            </Typography>
                                          </Grid>
                                        </Grid>
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                );
                              }
                            )} */}

                          {finalSummaryList.policyTerms &&
                            finalSummaryList.policyTerms.length > 0 &&
                            finalSummaryList.policyTerms.map((policyGroup) => {
                              const productName =
                                productMap.get(
                                  Number(policyGroup.policyTermProductId)
                                ) || "";

                              return (
                                <Grid
                                  key={policyGroup.policyTermProductId}
                                  container
                                >
                                  <Grid item lg={12} md={12} sm={12} xs={12}>
                                    <Typography
                                      className={classes.bodyPrint1}
                                      pt={2}
                                    >
                                      <strong>{productName}</strong>
                                    </Typography>
                                  </Grid>

                                  {policyGroup.policyTermsDescriptionArray.map(
                                    (term) => (
                                      <Grid
                                        key={term.id}
                                        container
                                        spacing={2}
                                        alignItems="center"
                                        padding={1}
                                      >
                                        <Grid
                                          item
                                          lg={12}
                                          md={12}
                                          sm={12}
                                          xs={12}
                                        >
                                          <Grid
                                            container
                                            spacing={2}
                                            alignItems="center"
                                          >
                                            <Grid
                                              item
                                              lg={0.5}
                                              md={0.5}
                                              sm={0.5}
                                              xs={0.5}
                                              display="flex"
                                              justifyContent="flex-start"
                                              alignItems="flex-start"
                                            >
                                              <Typography
                                                sx={{
                                                  fontSize: 13,
                                                  display: "flex",
                                                  justifyContent: "center",
                                                  alignItems: "center",
                                                  width: 18,
                                                  height: 18,
                                                  borderRadius: "50%",
                                                  border: "1px solid",
                                                  textAlign: "center",
                                                  lineHeight: "13px",
                                                  color: "black",
                                                }}
                                              >
                                                {"✔"}
                                              </Typography>
                                            </Grid>
                                            <Grid
                                              item
                                              lg={11.5}
                                              md={11.5}
                                              sm={11.5}
                                              xs={11.5}
                                            >
                                              {/* <Typography
                                                className="headingSummary"
                                                sx={{
                                                  pb: "2px",
                                                  color: "black",
                                                }}
                                              >
                                                {term.policyTermsDescription}
                                              </Typography> */}
                                              <Typography
                                                className={classes.bodyPrint133}
                                                component="div"
                                                dangerouslySetInnerHTML={{
                                                  __html:
                                                    term.policyTermsDescription,
                                                }}
                                              />
                                            </Grid>
                                          </Grid>
                                        </Grid>
                                      </Grid>
                                    )
                                  )}
                                </Grid>
                              );
                            })}

                          {finalSummaryList.summaryReport &&
                            finalSummaryList.summaryReport
                              .policySummaryRemark && (
                              <Grid
                                container
                                spacing={2}
                                alignItems="center"
                                padding={1}
                              >
                                <Grid item lg={12} md={12} sm={12} xs={12}>
                                  <Grid
                                    container
                                    spacing={2}
                                    alignItems="center"
                                  >
                                    <Grid item lg={12} md={12} sm={12} xs={12}>
                                      <Typography
                                        className={classes.bodyPrint1}
                                        pt={2}
                                      >
                                        <strong>Additional Terms</strong>
                                      </Typography>
                                    </Grid>
                                    <Grid
                                      item
                                      lg={0.5}
                                      md={0.5}
                                      sm={0.5}
                                      xs={0.5}
                                      display="flex"
                                      justifyContent="flex-start"
                                      alignItems="flex-start"
                                    >
                                      <Typography
                                        sx={{
                                          fontSize: 13,
                                          display: "flex",
                                          justifyContent: "center",
                                          alignItems: "center",
                                          width: 18,
                                          height: 18,
                                          borderRadius: "50%",
                                          border: "1px solid",
                                          textAlign: "center",
                                          lineHeight: "13px",
                                          color: "black",
                                        }}
                                      >
                                        {"✔"}
                                      </Typography>
                                    </Grid>
                                    <Grid
                                      item
                                      lg={11.5}
                                      md={11.5}
                                      sm={11.5}
                                      xs={11.5}
                                    >
                                      {/* <Typography
                                        className="headingSummary"
                                        sx={{
                                          pb: "2px",
                                          color: "black",
                                        }}
                                      >
                                        {
                                          finalSummaryList?.summaryReport
                                            ?.policySummaryRemark
                                        }
                                      </Typography> */}

                                      <Typography
                                        className={classes.bodyPrint133}
                                        component="div"
                                        dangerouslySetInnerHTML={{
                                          __html:
                                            finalSummaryList?.summaryReport
                                              ?.policySummaryRemark,
                                        }}
                                      />
                                    </Grid>
                                  </Grid>
                                </Grid>
                              </Grid>
                            )}
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Card>
          </PrintContainer>
        </Grid>
        <Grid item lg={12} md={12} sm={12} xs={12}>
          <Card className={classes.quotesCardInvoice}>
            <Grid container spacing={1} padding={"2px"}>
              <Grid
                item
                lg={12}
                md={12}
                sm={12}
                xs={12}
                sx={{ display: "flex", justifyContent: "flex-end" }}
              >
                <Grid
                  container
                  spacing={1}
                  justifyContent="flex-end"
                  sx={{ display: "flex" }}
                >
                  <Grid item>
                    <ReactToPrint
                      trigger={() => (
                        <Button
                          variant="contained"
                          startIcon={<LocalPrintshopSharpIcon />}
                          className={classes.addButton}
                        >
                          Print
                        </Button>
                      )}
                      content={() => componentRef.current}
                      pageStyle={`
                      @page {
                        margin: 5mm 1mm 10mm 1mm;

                        @top-right-corner {
                            content: "  ";
                          }
                        @bottom-right {
                          content: "Page " counter(page);
                        }
                      }
                      @media print {
                        body {
                          margin: 0;
                          padding: 0;
                        }
                  
                        table {
                          margin: 0 !important;
                          padding: 0 !important;
                          border-collapse: collapse !important;
                        }
                  
                        th, td {
                          padding: 4px !important; /* Optional: you can control cell spacing here */
                        }
                      }
                      `}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Card>
        </Grid>
      </Grid>
    </div>
  );
};

export default Index;
